module.exports = __webpack_public_path__ + "img/002.9cdce353.png";